/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assetlibrarypickerempty3Inputs */

const en_assetlibrarypickerempty3 = /** @type {(inputs: Assetlibrarypickerempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No images in your library yet.`)
};

const de_assetlibrarypickerempty3 = /** @type {(inputs: Assetlibrarypickerempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bilder in deiner Mediathek.`)
};

/**
* | output |
* | --- |
* | "No images in your library yet." |
*
* @param {Assetlibrarypickerempty3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const assetlibrarypickerempty3 = /** @type {((inputs?: Assetlibrarypickerempty3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assetlibrarypickerempty3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assetlibrarypickerempty3(inputs)
	return de_assetlibrarypickerempty3(inputs)
});
export { assetlibrarypickerempty3 as "assetLibraryPickerEmpty" }